import React from 'react'
import styled from 'styled-components'

import { FooterMenuEntry } from '../FooterLinks'
import * as Styled from './styled'

export interface FooterLinksGroupProps {
  className?: string
  heading?: string
  subHeading?: string
  links: FooterMenuEntry[]
}

const FooterLinksGroup: React.FC<FooterLinksGroupProps> = ({
  className,
  links,
  heading,
  subHeading,
}) => {
  return (
    <nav className={className}>
      <Styled.FooterLinksList>
        {heading ? <Styled.HeadingListEntry>{heading}</Styled.HeadingListEntry> : null}
        {subHeading ? <Styled.SubheadingListEntry>{subHeading}</Styled.SubheadingListEntry> : null}
        {links.map((item, index) => (
          <Styled.FooterLinksListEntry key={index}>
            <Styled.LinkEntry to={item.link || undefined}>{item.name}</Styled.LinkEntry>
          </Styled.FooterLinksListEntry>
        ))}
      </Styled.FooterLinksList>
    </nav>
  )
}

const StyledFooterLinksGroup = styled(FooterLinksGroup)`
  display: none;
  @media (min-width: 992px) {
    display: block;
  }
`

export { StyledFooterLinksGroup as FooterLinksGroup }
